module.exports = __webpack_public_path__ + "static/media/CBS.9259c048.png";